export default [
    {
      'title': 'Meeting',
      'start': new Date(2023, 3, 12, 14, 0, 0, 0),
      'end': new Date(2023, 3, 12, 15, 0, 0, 0)
    },
    {
      'title': 'Happy Hour',
      'start': new Date(2023, 7, 12, 17, 0, 0, 0),
      'end': new Date(2023, 7, 12, 17, 30, 0, 0),
      desc: 'Most important meal of the day'
    },
    {
      'title': 'Dinner',
      'start': new Date(2023, 7, 12, 20, 0, 0, 0),
      'end': new Date(2023, 7, 12, 21, 0, 0, 0)
    },
    {
      'title': 'Birthday Party',
      'start': new Date(2023, 7, 13, 7, 0, 0),
      'end': new Date(2023, 7, 13, 10, 30, 0)
    },
    {
      'title': 'Birthday Party 2',
      'start': new Date(2023, 7, 13, 7, 0, 0),
      'end': new Date(2023, 7, 13, 10, 30, 0)
    },
    {
      'title': 'Birthday Party 3',
      'start': new Date(2023, 7, 13, 7, 0, 0),
      'end': new Date(2023, 7, 13, 10, 30, 0)
    },
    {
      'title': 'Late Night Event',
      'start': new Date(2023, 7, 17, 19, 30, 0),
      'end': new Date(2023, 7, 18, 2, 0, 0)
    },
    {
      'title': 'Multi-day Event',
      'start': new Date(2023, 7, 20, 19, 30, 0),
      'end': new Date(2023, 7, 22, 2, 0, 0)
    }
  ]
  